import { isArray } from "lodash";
import { FC } from "react";

import { TagsCell, TagsCellByIds } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const TagsCellTemplate: FC<IRenderColumnTemplate> = ({ value }) => {
  if (value && typeof value === "string") {
    return <TagsCell value={value} />;
  }

  if (isArray(value)) {
    <TagsCellByIds value={value} />;
  }

  return null;
};
